import { FsAdvancedMarker } from '@lib/geo/google/map';

import { LprQueryResultsModel } from '../api/models';

export class FsQueryReadAdvancedMarker extends FsAdvancedMarker {
  constructor(public readonly queryRead: LprQueryResultsModel) {
    super({
      position: new google.maps.LatLng(
        queryRead.geometry.coordinates[1],
        queryRead.geometry.coordinates[0],
      ),
      title: queryRead.id,
      content: document.createElement('div'),
      collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
    });
    const content: any = this.getMarker().content;
    content.classList.add('fs__lpr-read-advanced-marker');

    content.style.border = '2px solid #fff';
    content.innerHTML = '<img class="fs__lpr-read-icon" src="/assets/fusus-icons/PNG/car.png"/>';
  }
}
